import { useAuth } from '../../../context/AuthContext';
import { useI18n } from '../../../i18n';

const TARGET_TENANT_NAME_KEY = 'vianet-impersonation-target-name';

// ═══════════════════════════════════════════════════════════════════════
// ImpersonationBanner — prompt 0524
// Banner amarillo permanente que aparece cuando el SUPERADMIN_PLATFORM
// está suplantando a otro tenant. Patrón Stripe/Linear:
//   "Estás suplantando ${tenantId} (${userEmail original}) · [Volver a mi cuenta]"
// El click en "Volver a mi cuenta" llama a AuthContext.endImpersonation().
// ═══════════════════════════════════════════════════════════════════════

export function ImpersonationBanner() {
  const { isImpersonating, user, endImpersonation } = useAuth();
  const { t } = useI18n();

  if (!isImpersonating || !user) {
    return null;
  }

  const banner = t.backoffice.impersonate;

  const handleVolver = async () => {
    await endImpersonation();
  };

  return (
    <div
      data-testid="impersonation-banner"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 9999,
        background: '#FCD34D', // amber-300
        borderBottom: '2px solid #D97706', // amber-600
        color: '#78350F', // amber-900
        padding: '8px 20px',
        fontSize: 13,
        fontWeight: 600,
        fontFamily: 'DM Sans, sans-serif',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
      }}
    >
      <span>
        <span aria-hidden style={{ marginRight: 8 }}>
          ⚠️
        </span>
        {banner.banner
          .replace('{tenant}', sessionStorage.getItem(TARGET_TENANT_NAME_KEY) ?? user.tenantId)
          .replace('{email}', user.originalEmail ?? '')}
      </span>
      <button
        data-testid="impersonation-banner-volver"
        onClick={handleVolver}
        style={{
          padding: '6px 14px',
          background: '#78350F',
          color: '#FCD34D',
          border: 'none',
          borderRadius: 6,
          fontSize: 12,
          fontWeight: 700,
          cursor: 'pointer',
          fontFamily: 'inherit',
          whiteSpace: 'nowrap',
        }}
      >
        {banner.bannerVolver}
      </button>
    </div>
  );
}
